import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Container, Nav, Dropdown } from 'react-bootstrap';
import './NavAdmin.css';

const NavAdmin = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname;

    const isUserGroupActive = ['/admin/listUser', '/admin/listEmployee', '/admin/ewallet'].includes(currentPath);
    const isParkingGroupActive = ['/admin/parkinglot', '/admin/vehicles'].includes(currentPath);

    return (
        <div className="admin-sub-navbar border-bottom bg-white py-2 shadow-xs">
            <Container>
                <Nav className="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                    {/* Dashboard */}
                    <NavLink
                        to="/"
                        end
                        className={({ isActive }) =>
                            `admin-nav-item btn btn-sm rounded-pill px-4 py-2 fw-semibold d-flex align-items-center gap-2 ${
                                isActive ? "btn-primary text-white shadow-sm" : "btn-light text-secondary"
                            }`
                        }
                    >
                        <i className="bi bi-speedometer2"></i>
                        <span>Dashboard tổng quan</span>
                    </NavLink>

                    {/* Group 1: Quản lý Tài khoản & Ví */}
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            className={`admin-nav-item btn btn-sm rounded-pill px-4 py-2 fw-semibold d-flex align-items-center gap-2 border-0 ${
                                isUserGroupActive ? "btn-primary text-white shadow-sm" : "btn-light text-secondary"
                            }`}
                        >
                            <i className="bi bi-people-fill"></i>
                            <span>Quản lý Tài khoản & Ví</span>
                            <i className="bi bi-chevron-down ms-1 small opacity-75"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="shadow-lg rounded-4 border-0 mt-2 p-2">
                            <Dropdown.Item
                                onClick={() => navigate('/admin/listUser')}
                                className={`rounded-3 py-2 px-3 fw-medium d-flex align-items-center gap-2 mb-1 ${currentPath === '/admin/listUser' ? 'active bg-primary text-white' : ''}`}
                            >
                                <i className="bi bi-people-fill text-primary"></i>
                                <span>Khách hàng / Người dùng</span>
                            </Dropdown.Item>

                            <Dropdown.Item
                                onClick={() => navigate('/admin/listEmployee')}
                                className={`rounded-3 py-2 px-3 fw-medium d-flex align-items-center gap-2 mb-1 ${currentPath === '/admin/listEmployee' ? 'active bg-primary text-white' : ''}`}
                            >
                                <i className="bi bi-person-badge-fill text-info"></i>
                                <span>Nhân viên bãi xe</span>
                            </Dropdown.Item>

                            <Dropdown.Divider className="my-1" />

                            <Dropdown.Item
                                onClick={() => navigate('/admin/ewallet')}
                                className={`rounded-3 py-2 px-3 fw-medium d-flex align-items-center gap-2 ${currentPath === '/admin/ewallet' ? 'active bg-primary text-white' : ''}`}
                            >
                                <i className="bi bi-wallet2 text-success"></i>
                                <span>Ví điện tử người dùng</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* Group 2: Bãi xe & Phương tiện */}
                    <Dropdown>
                        <Dropdown.Toggle
                            as="button"
                            className={`admin-nav-item btn btn-sm rounded-pill px-4 py-2 fw-semibold d-flex align-items-center gap-2 border-0 ${
                                isParkingGroupActive ? "btn-primary text-white shadow-sm" : "btn-light text-secondary"
                            }`}
                        >
                            <i className="bi bi-p-square-fill"></i>
                            <span>Bãi xe & Phương tiện</span>
                            <i className="bi bi-chevron-down ms-1 small opacity-75"></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="shadow-lg rounded-4 border-0 mt-2 p-2">
                            <Dropdown.Item
                                onClick={() => navigate('/admin/parkinglot')}
                                className={`rounded-3 py-2 px-3 fw-medium d-flex align-items-center gap-2 mb-1 ${currentPath === '/admin/parkinglot' ? 'active bg-primary text-white' : ''}`}
                            >
                                <i className="bi bi-p-square-fill text-primary"></i>
                                <span>Khu vực bãi giữ xe</span>
                            </Dropdown.Item>

                            <Dropdown.Item
                                onClick={() => navigate('/admin/vehicles')}
                                className={`rounded-3 py-2 px-3 fw-medium d-flex align-items-center gap-2 ${currentPath === '/admin/vehicles' ? 'active bg-primary text-white' : ''}`}
                            >
                                <i className="bi bi-car-front-fill text-info"></i>
                                <span>Phương tiện đăng ký</span>
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    {/* Revenue */}
                    <NavLink
                        to="/admin/revenue"
                        className={({ isActive }) =>
                            `admin-nav-item btn btn-sm rounded-pill px-4 py-2 fw-semibold d-flex align-items-center gap-2 ${
                                isActive ? "btn-primary text-white shadow-sm" : "btn-light text-secondary"
                            }`
                        }
                    >
                        <i className="bi bi-graph-up-arrow"></i>
                        <span>Thống kê doanh thu</span>
                    </NavLink>

                    {/* Membership Manage */}
                    <NavLink
                        to="/admin/membership-manage"
                        className={({ isActive }) =>
                            `admin-nav-item btn btn-sm rounded-pill px-4 py-2 fw-semibold d-flex align-items-center gap-2 ${
                                isActive ? "btn-primary text-white shadow-sm" : "btn-light text-secondary"
                            }`
                        }
                    >
                        <i className="bi bi-shield-lock-fill text-warning"></i>
                        <span>Quản lý Gói Thành Viên</span>
                    </NavLink>
                </Nav>
            </Container>
        </div>
    );
};

export default NavAdmin;